import {ONLY_MARKER_ZOOM} from "../constants";

export const initSectionInfrastructure = ( mapNode, ymapsMap, ymapsObjectManager, ymapsClusterObjectManager ) => {
	const component = mapNode.closest(`section.infrastructure`);

	if ( component )
	{
		const filters = component.querySelector(`div.filters`);
		const checkboxes = Array.from(component.querySelectorAll(`[type="checkbox"]`));
		const infrastructureAll = filters.querySelector(`[id="infrastructure_all"]`);
		const infrastructureWayToSubway = filters.querySelector(`[id="infrastructure_way_to_subway"]`);

		const MapCoordinates = {
			LATITUDE: mapNode.getAttribute(`data-latitude`),
			LONGITUDE: mapNode.getAttribute(`data-longitude`),
			ZOOM: mapNode.getAttribute(`data-zoom`),
		};
		
		ymapsObjectManager.setFilter((object) => object.properties.complex === `yes` );
		
		filters.addEventListener(`change`, ({target}) => {
			if ( target.type !== `radio` )
			{
				infrastructureAll.checked = false;
				infrastructureWayToSubway.checked = false;
			}

			if ( target.type !== `checkbox` )
			{
				checkboxes.forEach((checkbox) => checkbox.checked = false );
			}
			
			if ( target !== infrastructureWayToSubway)
			{
				const elements = target === infrastructureAll ? [] : Array.from(filters.querySelectorAll(`input[type="checkbox"]:not(:checked)`));
				let hiddenElements = ``;

				elements.forEach( (el, i) => {
					hiddenElements += 'properties.group !== "' + elements[i].id + '"';

					if ( i !== elements.length - 1)
					{
						hiddenElements += ' && ';
					}
				});

				ymapsClusterObjectManager.setFilter( hiddenElements );
				ymapsObjectManager.setFilter((object) => object.properties.complex === `yes` );

				if ( target === infrastructureAll
					&& MapCoordinates.LATITUDE
					&& MapCoordinates.LONGITUDE
					&& MapCoordinates.ZOOM
				)
				{
					ymapsMap.setCenter( [MapCoordinates.LATITUDE, MapCoordinates.LONGITUDE], MapCoordinates.ZOOM, {checkZoomRange: true, duration: 300, useMapMargin: true} );
				}
			} else 
			{
				ymapsClusterObjectManager.setFilter((object) => !object.properties.group );
				ymapsObjectManager.setFilter();

				const metroMarker = ymapsObjectManager.objects.getAll().find((el) => el.properties.subwayLine );
				
				ymapsMap.setBounds( ymapsObjectManager.getBounds(), {checkZoomRange: true, duration: 300, useMapMargin: true} ).then(() => ymapsObjectManager.objects.balloon.open( metroMarker.id ));
			}
		});
	}
};
